import globalStyles from '../../globalStyles';
const styles = {
  ...globalStyles,
  welcome_user: {
    'margin-bottom': '10px',
  },
};

export default styles;
